import { Select, Row, Col, Form, Checkbox, Input, DatePicker } from "antd";
import { forwardRef, useImperativeHandle } from "react";
import { useDispatch, useSelector } from "react-redux";
import { update_pregnancylist_form } from "../../actions/form_slice";
import { debounce } from "lodash";
const { Option } = Select;
const PREGNANCYLIST = forwardRef(({ onValuesChange }, ref) => {
  const [form] = Form.useForm();

  useImperativeHandle(ref, () => ({
    getFieldsError: form.getFieldsError,
    validateFields: form.validateFields,
    resetFields: form.resetFields,
    setFieldsValue: form.setFieldsValue,
    submit: form.submit,
    getFieldsValue: form.getFieldsValue,
  }));

  const dispatch = useDispatch();
  const formData = useSelector((state) => state.form.pregnancylist_form_type);

  const handleFormChange = debounce((changedValues) => {
    dispatch(update_pregnancylist_form(changedValues));
    onValuesChange(formData);
  }, 300);

  return (
    <Form
      form={form}
      onValuesChange={handleFormChange}
      // onFinish={props.onFinish}
      labelAlign="justify"
      style={{ maxWidth: "100%" }}
    >
      <Row>
        <Col span={16} style={{ fontWeight: "bold" }}>
          Screen Name: PREGNANCY LIST (All Programs)
        </Col>
        <Col span={8}>
          <Form.Item
            name="Status"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Select defaultValue="Selected Status" style={{ width: 200 }}>
              <Option value="Selected Status">
                <strong>Selected Status</strong>
              </Option>
              <Option value="N/A">N/A</Option>
              <Option value="COMPLETE">COMPLETE</Option>
              <Option value="PENDING">PENDING</Option>
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <Form.Item
            valuePropName="checked"
            name="Is anyone in the household pregnant?"
          >
            <Checkbox value="Is anyone in the household pregnant?">
              Is anyone in the household pregnant?
            </Checkbox>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="Due Date" label="Due Date">
            <DatePicker
              style={{ width: "100%", color: "#000000" }}
              allowClear
              // format={"YYYY-MM-DD"}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Form.Item name="Comments" label="Comments">
          <Input style={{ width: "100%" }} />
        </Form.Item>
        <Form.Item name="Pending for" label="Pending for:">
          <Input style={{ width: "100%" }} />
        </Form.Item>
      </Row>
    </Form>
  );
});
export default PREGNANCYLIST;
